(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bobbin-offer"] && !Shopify.designMode) return;
  try {
    class OddsOffer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.#onChange);
      // Apply the default tier so the form matches what is visibly selected.
      requestAnimationFrame(() => this.#sync(this.querySelector('.so-tier__input:checked')));
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.#onChange);
    }

    #onChange = (event) => {
      const input = event.target;
      if (input instanceof HTMLInputElement && input.classList.contains('so-tier__input')) {
        this.#sync(input);
      }
    };

    get #form() {
      const sectionId = this.dataset.sectionId;
      return (
        document.getElementById(`BuyButtons-ProductForm-${sectionId}`) ||
        this.closest('.shopify-section')?.querySelector('form[data-type="add-to-cart-form"]')
      );
    }

    #sync(input) {
      if (!input) return;
      const form = this.#form;
      if (!form) return;

      const variantId = input.dataset.variantId;
      const quantity = input.dataset.quantity || '1';

      const variantField = form.querySelector('input[name="id"]');
      if (variantField && variantId) variantField.value = variantId;

      // The quantity block is optional in the template, so own a hidden field
      // when the merchant has not placed a visible quantity selector.
      let quantityField = form.querySelector('[name="quantity"]');
      if (!quantityField) {
        quantityField = document.createElement('input');
        quantityField.type = 'hidden';
        quantityField.name = 'quantity';
        form.appendChild(quantityField);
      }
      quantityField.value = quantity;

      this.dispatchEvent(
        new CustomEvent('bobbin:offer:change', {
          bubbles: true,
          detail: { variantId, quantity: Number(quantity), subtotal: input.dataset.subtotal },
        })
      );
    }
  }

  if (!customElements.get('so-offer')) {
    customElements.define('so-offer', OddsOffer);
  }
  } catch(e) { console.error(e); }
})();

})();
